"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _row = require("../basic/row");

var _row2 = _interopRequireDefault(_row);

var _col = require("../basic/col");

var _col2 = _interopRequireDefault(_col);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var List = _react2["default"].createClass({
	displayName: "List",
	getDefaultProps: function getDefaultProps() {
		return {
			data: { "数据错误": "未传入data" }
		};
	},
	render: function render() {
		var toReturn = [];
		var dummyKey = 0;
		for (var i in this.props.data) {
			toReturn.push(_react2["default"].createElement(
				_row2["default"],
				{ key: dummyKey++ },
				_react2["default"].createElement(
					_col2["default"],
					{ span: "12", style: { textAlign: "right" } },
					i + ":",
					"  "
				),
				_react2["default"].createElement(
					_col2["default"],
					{ span: "12", style: { textAlign: "left" } },
					" ",
					this.props.data[i]
				)
			));
		}
		return _react2["default"].createElement(
			"div",
			{ style: { "marginBottom": 10 } },
			toReturn
		);
	}
});

exports["default"] = List;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/business/list.jsx
 ** module id = 626
 ** module chunks = 0
 **/